import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { AdminService } from '@app/services/admin.service';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Constants } from '@app/shared-module/constants';

@Component({
  selector: 'app-hard-reset-password',
  templateUrl: './hard-reset-password.component.html',
  styleUrls: ['./hard-reset-password.component.scss']
})
export class HardResetPasswordComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  headerTitle: string;
  emailId: string;
  newPassword: string;
  confirmPassword: string;
  showNewPassword = false;
  shownConfirmPassword = false;

  constructor(
    public dialogRef: MatDialogRef<HardResetPasswordComponent>,
    private service: AdminService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {}

  resetPassword() {
    this.dialogRef.close(true);
    if (this.newPassword.length > 6 && this.confirmPassword.length > 6) {
      if (this.newPassword === this.confirmPassword) {
        this.blockUI.start('Updating...');
        this.service.hardResetPassword(this.emailId, this.newPassword).subscribe(
          res => {
            if (res) {
              this.blockUI.stop();
              this.dialogRef.close(true);
              this.toastr.success('Password Reset Successfully');
            }
          },
          error => {
            setTimeout(() => {
              this.blockUI.stop();
            }, 200);
            this.toastr.error(Constants.LABEL_ERROR, 'Password reset failed');
          }
        );
      } else {
        console.log('passwords mismatch');
        this.toastr.error(Constants.LABEL_ERROR, 'Confirm Password doesnot match with New Password');
      }
    } else {
      this.toastr.error(Constants.LABEL_ERROR, 'Password length must be greater than 6 characters');
    }
  }
}
